import './saml2.login-system.less';
import AbstractLoginSystem from '../abstract-login-system';
import AbstractLoginSystemController from '../abstract-login-system-controller';
import type {IWindowService} from 'angular';
import type WalkerService from '../../../../services/walker.service';

export class Saml2LoginSystemComponentController extends AbstractLoginSystemController {

    /*@ngInject*/
    constructor(private $window: IWindowService, private walker: WalkerService) {
        super();
    }

    public redirect() {
        this.walker.newPageOnContext(`/saml2/authenticate/sso?redirect=${encodeURIComponent(this.$window.location.href)}`);
    }
}

 
export default class Saml2LoginSystemComponent extends AbstractLoginSystem {
    public static componentName = 'saml2.loginSystem';

    public templateUrl = require('./saml2.login-system.tpl.ftl');

    public controller = Saml2LoginSystemComponentController;
}
